import React, { ChangeEvent, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import NotasInput from './notasInput';

interface NotaFormat {
  date: string,
  user: string,
  message: string
}

interface NotasProps{
  notas: string,
  setNotas: any,
  intl: any,
  disabled: boolean
}


function Notas({ notas, setNotas, disabled, intl }: NotasProps) {
  const [notaText, setNotaText] = useState('');
  const [visible, setVisible] = useState(false);
  const [emptyError, setEmptyError] = useState(false);
  const [notasList, setNotasList] = useState<Array<NotaFormat>>([]);


  const expr = /\[ ([\d+\-]+) [\d+:]+ - ([\.a-zA-Z0-9,!? ]*)\]/i;

  useEffect(() => {
    const splitNotas = notas.split('\n');
    const copyNotasList = []
    for (let i = 0; i < splitNotas.length; i++) {
      const capture = splitNotas[i].match(expr);
      if (capture) {
        console.log('capture', capture)
        copyNotasList?.push({
          date: `${capture[1]}. `,
          user: capture[2],
          message: splitNotas[i + 1],
        });
        console.log('copyNotasList', copyNotasList)
        setNotasList(copyNotasList)
      }
    }
  }, [notas]);

  useEffect( () => {
    console.log('notasList', notasList)
  }, [notasList])


  function handleChange(e:ChangeEvent<HTMLInputElement>) {
    setNotaText(e.target.value);
    setEmptyError(false);
  }

  function addNote() {
    if (notaText !== '') {
      setNotas(notaText);
      setNotaText('');
    } else {
      setEmptyError(true);
    }
  }

  return (
    <div className="bodyInfo flexCol">
      <div className="notas_head">
        <h3>
          {intl.formatMessage({ id: 'pacientes.generic.titles.notas' })}
        &nbsp;
          { notasList && notasList.length > 0 ? `(${notasList.length})` : null}
        </h3>
        <p
          onClick={() => setVisible(!visible)}
          className="blueLink"
        >
          {intl.formatMessage({ id: `pacientes.new_client.${visible ? 'hide_notas' : 'see_notas'}` })}
        </p>
      </div>
      { visible
        ? (
          <div>
            {notasList?.map((note: NotaFormat, index: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <div className="flexCol" key={index}>
                <div className="flexCol">
                  <span className="note_head">
                    {note.date}
                    {note.user}
                  </span>
                  <p className="note_body">{note.message}</p>
                </div>
              </div>
            ))}
          </div>
        )
        : null
    }
      <div className="notasBox">
        <NotasInput disabled={disabled} addNote={addNote} handleChange={handleChange} notaText={notaText} emptyError={emptyError}/>
        <div>
          { emptyError
            ? <p className="errors">{intl.formatMessage({ id: 'pacientes.generic.error.saveNote' })}</p>
            : null
        }
        </div>
      </div>
    </div>
  );
}

export default injectIntl(Notas);
